
import { CircularProgress, Stack } from '@mui/material';
import { DBMyWorksThunks } from "@common-reducers/DBServiceThunks";
import { fetchMyWorkThunk } from '@common-reducers/MyWorkThunks';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useEffect } from 'react';
import MyWorkTaskList from '../my-work-task-list';
import MyWorkCustomizeDrawer from './my-work-customize-drawer';
import MyWorkHeader from './my-work-header';
import { bulkActions } from '@common-reducers/BulkActionsReducer';
import { pickerDialogActions } from '@common-reducers/PickerDialogReducer';


export default function MyWorkView() {
    const dispatch = useAppDispatch();

    const isLoading = useAppSelector(state => state.MyWorkReducer.myWorkIsLoading)

    useEffect(() => {
        dispatch(bulkActions.setBulkTasksMap({}));
        dispatch(pickerDialogActions.closePickerDialog());

        dispatch(DBMyWorksThunks.find({}))
        dispatch(fetchMyWorkThunk())

    }, [dispatch]);

    return (
        <Stack p={3} sx={{ width: "100%" }}>

            <MyWorkCustomizeDrawer />

            <Stack sx={{ width: "100%" }} direction={"column"}>
                <h2>My work</h2>
                {isLoading &&
                    <Stack sx={{ height: "70vh" }} justifyContent={"center"} alignItems={"center"}>
                        <CircularProgress />
                    </Stack>
                }


                {!isLoading &&
                    <>
                        <MyWorkHeader />
                        <MyWorkTaskList />
                    </>
                }
            </Stack>
        </Stack >
    );
}


